import { create } from 'zustand'

import type { Entity } from '@/modules/shared/types/entity.type'

import type { ScheduleCard } from '../types/shedule-card.type'

export type State = {
  operationType: 'add' | 'edit' | 'view'
  schedules: ScheduleCard[]
  isOpenModalCustomer: boolean
  customers: Entity[]
  selectedSchedule: ScheduleCard | null
  isOpenModalDetailsSchedule: boolean
}

export type Action = {
  actions?: {
    setOperationType: (operation: 'add' | 'edit' | 'view') => void
    setSchedules: (schedules: ScheduleCard[]) => void
    setIsOpenModalCustomer: (props: boolean) => void
    setCustomers: (payload: Entity[]) => void
    setSelectedSchedule: (schedule: ScheduleCard | null) => void
    setIsOpenModalDetailsSchedule: (props: boolean) => void
  }
}

export const ScheduleFormStore = create<State & Action>((set) => ({
  operationType: 'add',
  schedules: [],
  customers: [],
  isOpenModalCustomer: false,
  selectedSchedule: null,
  isOpenModalDetailsSchedule: false,
  actions: {
    setOperationType: (operation) => set({ operationType: operation }),
    setSchedules: (schedules) => set({ schedules }),
    setIsOpenModalCustomer: (props) => set({ isOpenModalCustomer: props }),
    setCustomers: (payload) => set({ customers: payload }),
    setSelectedSchedule: (schedule) => set({ selectedSchedule: schedule }),
    setIsOpenModalDetailsSchedule: (props) =>
      set({ isOpenModalDetailsSchedule: props }),
  },
}))

export const useScheduleFormStore = ScheduleFormStore
export const useScheduleFormStoreActions = () => {
  const { actions } = ScheduleFormStore.getState()
  return actions
}
